import React from 'react';
import aboutCover from '../assets/images/about.jpg';
import { useTranslation } from 'react-i18next';
import AboutSection from "../components/sections/AboutSection";
import {aboutText} from "../constants/data";
import {aboutMeta} from "../constants/meta";
import Meta from "../components/common/Helmet";
import Header from "../components/ui/Header";

const About = () => {
  const { t } = useTranslation();
  return (
    <div className="bg-gray-50">
      <Meta
        title={aboutMeta.title}
        description={aboutMeta.description}
        canonical={aboutMeta.canonical}
        keywords={aboutMeta.keywords}
        ogTitle={aboutMeta.title}
        ogDescription={aboutMeta.description}
      />
      <Header/>
      {/* Hero Section - Fixed for mobile */}
      <div className="relative w-full aspect-[16/9] md:aspect-[21/10] overflow-hidden">
        <img
          src={aboutCover}
          alt="About Cover"
          className="w-full h-full object-cover brightness-75"
        />
        {/* Gradient Overlay */}
        <div className="absolute inset-0 bg-gradient-to-t from-gray-900/50 to-transparent"></div>
        {/* About Section Content - Fixed positioning for mobile */}
        <div className="hidden md:block absolute inset-0 flex items-center justify-center">
          <AboutSection />
        </div>
      </div>

      {/* Main Content Container */}
      <div className="w-mobile-container md:w-theme-container mx-auto py-12 md:py-20">
        {/* Who We Are Section */}
        <section className="mb-16 md:mb-20">
          <h2 className="text-2xl md:text-4xl text-gray-800 mb-8 md:mb-12 text-center">
            {t('common.who')} <span className="text-theme-color">{t('common.weAre')} ?</span>
          </h2>
          <div className="flex flex-col md:grid md:grid-cols-2 gap-8 md:gap-12 items-center">
            <div className="w-full shadow-xl rounded-xl overflow-hidden order-1 md:order-1">
              <iframe
                className="w-full aspect-video"
                src="https://www.youtube.com/embed/HnwpoHLIECc"
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
            <div className="text-base md:text-xl text-gray-700 leading-relaxed order-2 md:order-2">
              <p className="mb-4 md:mb-6">
                {t('common.aboutText')}
              </p>
              <p>
                {t('common.weServe')}
              </p>
            </div>
          </div>
        </section>

        {/* How We Make Difference Section */}
        <section className="mb-16 md:mb-20">
          <h2 className="text-2xl md:text-4xl text-gray-800 mb-12 md:mb-16 text-center">
            {t('common.howWe')} <span className="text-theme-color">{t('common.makeADiff')}</span>
          </h2>
          <div className="space-y-8 md:space-y-16">
            {aboutText.map((text, index) => (
              <div
                key={index}
                className="bg-white p-6 md:p-8 rounded-xl shadow-md hover:shadow-lg transition-shadow duration-300"
              >
                <h3 className="text-xl md:text-2xl text-theme-color mb-4 md:mb-6">{t(`common.${text.titleTranslateKey}`)}</h3>
                <p className="text-gray-700 leading-relaxed text-sm md:text-base">
                  {t(`common.${text.descriptionTranslateKey}`)}
                </p>
              </div>
            ))}
          </div>
        </section>

        {/* Domain Expertise Section */}
        <section className="mb-12 md:mb-16">
          <h2 className="text-2xl md:text-4xl text-gray-800 mb-12 md:mb-16 text-center">
            {t('common.our')} <span className="text-theme-color">{t('common.domainExpertise')}</span>
          </h2>
          <div className="bg-white rounded-xl md:rounded-2xl shadow-xl p-6 md:p-12">
            <h2 className="text-xl md:text-3xl text-theme-color mb-4 md:mb-6 pb-3 md:pb-4 border-b border-gray-200">
              {t('common.customizeSoftwareDevelopment')}
            </h2>
            <p className="text-gray-700 leading-relaxed text-sm md:text-base mb-6 md:mb-8">
              {t('common.sinceTheEarly')}
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 mb-8 md:mb-10">
              {[
                t('common.eCommerce'),
                t('common.meetingRoomAndManagement'),
                t('common.inventory'),
                t('common.hr'),
                t('common.shipping'),
                t('common.warehouse'),
                t('common.rOAD'),
                t('common.eidForShipping'),
              ].map((item, index) => (
                <div key={index} className="flex items-start">
                  <div className="bg-primary/10 p-1 md:p-2 rounded-full mr-3 md:mr-4">
                    <svg className="w-4 h-4 md:w-5 md:h-5 text-theme-color" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                    </svg>
                  </div>
                  <span className="text-gray-700 text-sm md:text-base">{item}</span>
                </div>
              ))}
            </div>

            <p className="text-gray-700 leading-relaxed text-sm md:text-base">
              {t('common.theMesoftDevelopment')}

            </p>
          </div>
        </section>
      </div>
    </div>
  );
};

export default About;
